import ApiClient from "../ApiClient";

const appId = process.env.REACT_APP_DEFAULT_APP_ID; //pass the app ID based on login

function normalizeRevenueChartResponse(response) {
  const payload = response?.data?.data ?? response?.data ?? [];
  const rows = Array.isArray(payload) ? payload : [];

  return rows.map((item, index) => ({
    id: item?.id ?? `revenue-${index + 1}`,
    month: item?.month ?? item?.Month ?? "-",
    revenue: Number(item?.revenue ?? item?.Revenue ?? 0),
    eventCount: Number(item?.eventCount ?? item?.EventCount ?? 0),
  }));
}

const EventService = {
  async fetchDraftEvents() {
    if (!appId) throw new Error("appId is required");
    const resp = await ApiClient.get(`/Event/getall-draft-events`);
    return resp;
  },

  async saveEvent(formData) {
    if (!appId) throw new Error("appId is required");
    const rawEventId = formData.eventId;
    const hasPersistedEventId =
      rawEventId != null &&
      rawEventId !== "" &&
      rawEventId !== 0 &&
      rawEventId !== "0";

    const isUpdate = Boolean(hasPersistedEventId);
    const endpoint = isUpdate ? "/Event/update-event" : "/Event/create-event";

    // Use PUT for update, POST for create
    const method = isUpdate ? "put" : "post";

    const resp = await ApiClient[method](endpoint, formData);
    return resp;
  },

  async fetchDraftEventById(eventId) {
    if (!appId) throw new Error("appId is required");
    const resp = await ApiClient.get(`/Event/get-event/${eventId}`);
    return resp;
  },

  async getUserPaymentProfile() {
    const resp = await ApiClient.get("/Event/get-razorpay-profile");
    return resp.data.data;
  },

  async createUserPaymentProfile(formData) {
    const resp = await ApiClient.post(
      "/Event/create-razorpay-profile",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return resp.data;
  },

  async updateUserPaymentProfile(formData) {
    const resp = await ApiClient.put(
      "/Event/update-razorpay-profile",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return resp.data;
  },

  async deleteUserPaymentProfile() {
    const resp = await ApiClient.delete("/Event/delete-razorpay-profile");
    return resp.data;
  },

  async getEventRevenueChart(months = 3, options = {}) {
    const response = await ApiClient.get("/Event/event-revenue-chart", {
      params: { months },
      ...options,
    });

    return normalizeRevenueChartResponse(response);
  },

  async getUpcomingWebinar(email) {
    const resp = await ApiClient.get(`/Event/get-upcoming-webinars`, {
      params: { email }
    });
    return resp;
  },

   async getRazorPayKey() {
    const resp = await ApiClient.get(`/Event/get-razorpay-info`);
    return resp;
  },

  async fetchEventForRegistration(eventId, businessAdminId) {
    if (!appId) throw new Error("appId is required");
    const resp = await ApiClient.get(`/Event/get-registration-event/${eventId}`, {
      params: { businessAdminId }
    });
    return resp;
  },
};

export default EventService;
